import React from 'react';
import PropTypes from 'prop-types';

const FieldError = ({ error, touched, disabled = false }) => {
  const isTouched = Array.isArray(touched) ? true : touched; // For dealing with Formik/react-select

  return (
    <div>
      {disabled
        ? <small className='error mt-1 text-danger invisible' aria-label='No error'>No error</small>
        : error && isTouched
          ? <small aria-live='polite' role='region' className='error mt-1 text-danger' aria-label={error}>{error}</small>
          : <small className='error mt-1 text-danger invisible' aria-label='No error'>No error</small>}
    </div>
  );
};

FieldError.propTypes = {
  error: PropTypes.string,
  touched: PropTypes.oneOfType([
    PropTypes.bool,
    PropTypes.array,
  ]),
  disabled: PropTypes.bool,
};

export default FieldError;
